import React from 'react';
import Popover from 'components/Popover/Popover.react';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import Button from 'components/Button/Button.react';
import AceEditor from 'react-ace';

import 'brace/mode/javascript';
import 'brace/mode/json';
import 'brace/snippets/json';
import 'brace/ext/searchbox';
import 'brace/ext/language_tools';
import './sashido-theme';

import styles from './ACE.scss';


export default class ACE extends React.Component {
  constructor(props) {
    super();

    this.state = {
      value: props.value,
      newValue: props.value,
      error: {
        showError: false,
        text: null,
        line: null,
      },
    };

    this.timer = null;
  }

  onCancel() {
    this.props.onCancel();
  }

  onChange(newValue) {
    const { type } = this.props;
    clearTimeout(this.timer);
    const self = this;

    this.timer = setTimeout(() => {
      const annotations = self.refs.code.editor.session.$annotations;
      const showError = annotations.length > 0;
      const obj = annotations[0];

      let saveMe;
      try {
        saveMe = JSON.parse(newValue);
      } catch (e) {}

      if (saveMe && saveMe.constructor.name !== type) {
        this.setState({
          newValue,
          error: {
            showError: true,
            text: `You should use ${type} instead of ${saveMe.constructor.name || typeof newValue}`,
            line: 1,
          },
        });

        return null;
      }

      // TODO: fix gutter color change on scroll
      // if (showError) {
      //   document.querySelector('.ace_error').previousSibling.classList.add('error-on-line');
      // } else {
      //   document.querySelector('.error-on-line').classList.remove('error-on-line');
      // }

      this.setState({
        newValue,
        error: {
          showError,
          text: showError ? obj.text : '',
          line: obj ? obj.row : null,
        },
      });
    }, 400);
  }

  onSave() {
    const { value, newValue } = this.state;
    let saveThis;

    if (newValue.length !== 0) {
      saveThis = newValue;
    }

    if (value !== newValue) {
      saveThis = newValue;
    }

    this.props.onCommit(saveThis);
  }

  render() {
    const details = (
      this.state.error.showError
        ? (
          <div className={styles.details}>
            <span className={styles.errMessage}>{this.state.error.text}</span> on line <strong>{this.state.error.line}</strong>
          </div>
        )
        : null
    );

    const subtitle_element = this.props.subtitle ? <div className={styles.subtitle}>{this.props.subtitle}</div> : null;

    return (
      <Popover modal color="rgba(34,41,51,0.8)">
        <div className={styles.holder}>
          <div className={styles.editor}>
            <div className={styles.header}>
              <div className={styles.title}>
                {this.props.title}
                {subtitle_element}
              </div>
            </div>
            <div className={styles.content}>
              <div className={styles.showEffect}>
                <LoaderDots />
              </div>
              <AceEditor
                name="codeEditor"
                ref="code"
                width="100%"
                height="100%"
                value={this.state.newValue}
                mode="json"
                tabSize={2}
                enableSnippets
                enableBasicAutocompletion
                enableLiveAutocompletion
                showPrintMargin={false}
                theme="sashido"
                setOptions={{
                  cursorStyle: 'smooth',
                  showInvisibles: true,
                  displayIndentGuides: true,
                  wrap: false,
                  tooltipFollowsMouse: false,
                }}
                onChange={this.onChange.bind(this)}
                onLoad={(editor) => {
                  editor.focus();
                  editor.gotoLine(1);
                }}
                editorProps={{ $blockScrolling: Infinity }} />
            </div>
            <div className={styles.footer}>
              {details}

              <Button
                value="Cancel"
                onClick={() => this.onCancel()} />

              {
                // TODO: pivanov
                // this.props.copy
                //   ?
                //     <span>copy</span>
                //   :
                //     null
              }

              {
                this.props.hideSaveButton
                  ?
                    null
                  :
                    <Button
                      value="Save"
                      disabled={this.state.error.showError}
                      color="green"
                      onClick={this.onSave.bind(this)} />
              }
            </div>
          </div>
        </div>
      </Popover>
    );
  }
}
